import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import BeatLoader from 'react-spinners/BeatLoader';
import SingleForm from '../components/single-form';

const Form = () => {
  const { id } = useParams();
  const [single, setSingle] = useState();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch(`https://www.wheretoshoot.org/wp-json/range-form/v1/form/${id}`)
      .then((res: any) => res.json())
      .then((result: any) => {
        setSingle(result[0]);
        setLoading(false);
      });
  }, []);
  return (
    <>
      {loading === true ? (
        <Div>
          <p>Loading form</p>
          <BeatLoader color="#4a6568" size={30} margin={10} />
        </Div>
      ) : (
        <Wrapper>
          <StyledLink to="/edit-range/find-range">Back to Search</StyledLink>
          {single && <SingleForm form={single} />}
        </Wrapper>
      )}
    </>
  );
};

export default Form;

const Div = styled.div`
  height: 80vh;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  p {
    width: 100%;
    text-align: center;
  }
`;

const Wrapper = styled.div`
  min-height: 70vh;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 1170px;
  margin: 30px auto;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
  width: 100%;
  padding: 10px 0;
`;
